/**
 * بارامترات طلب GET /event_requests للأدمن.
 * البحث والفلاتر الأساسية نفس بوابة الشركة؛ الفروقات الأدمن فقط أدناه.
 */
import { joiningRequestStatuses } from "./constants";
import {
  buildEventRequestListParams,
  buildEventRequestSearchParams,
  readEventCompanyId,
} from "./eventRequestMappers";

const mapAdminCheckInFilterToApiValue = (checkInFilter) => {
  const value = checkInFilter?.value;

  if (value === "checked_in" || value === true) return true;
  if (value === "not_checked_in" || value === false) return false;

  return undefined;
};

export const buildAdminEventRequestListParams = ({
  eventId,
  event,
  activeStatus,
  search,
  filters,
  page,
  pageSize,
}) => {
  const companyId = readEventCompanyId(event);
  const baseParams = buildEventRequestListParams({
    eventId,
    activeStatus,
    search: "",
    filters: {
      ...filters,
      applicantType: null,
    },
    page,
    pageSize,
    companyId,
  });

  const sharedParams = { ...baseParams };
  delete sharedParams.user_name;
  delete sharedParams.user_id;
  delete sharedParams.event_role_shift_type;
  delete sharedParams.loyal_applicants;
  delete sharedParams.non_loyal_applicants;
  delete sharedParams.is_checked_in;

  const checkInValue =
    activeStatus === joiningRequestStatuses.joined
      ? mapAdminCheckInFilterToApiValue(filters?.checkIn)
      : undefined;

  const params = {
    ...sharedParams,
    event_id: eventId,
    ...(companyId ? { company_id: companyId } : {}),
    order_by_created_at: "asc",
    ...buildEventRequestSearchParams(search),
    ...(filters?.shift?.id ? { event_role_shift_id: filters.shift.id } : {}),
    ...(checkInValue !== undefined ? { is_checked_in: checkInValue } : {}),
  };

  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null),
  );
};
